import { Handler, Result, err, DataModel, ComplexModel, SimpleModel } from './handler';
import { Path } from './path';
import { SchemaError, ErrorCode } from './schema-error';

export function simple(
  type: SimpleType,
  getter: ((data: SimpleModel) => Result<string, SchemaError>) | null,
  setter: ((data: SimpleModel, value: string) => Result<ComplexModel, SchemaError>) | null) {

  const result = new Simple(type, getter, setter);
  return result;
}

export enum SimpleType {
  readWrite,
  readOnly,
  writeOnly
}

export class Simple implements Handler {

  constructor(
    private type: SimpleType,
    private getter: ((data: SimpleModel) => Result<string, SchemaError>) | null,
    private setter: ((data: SimpleModel, value: string) => Result<ComplexModel, SchemaError>) | null) {

  }

  public get(path: Path, data: ComplexModel): Result<string, SchemaError> {

    if (this.type === SimpleType.writeOnly || !this.getter) {
      return err(new SchemaError(ErrorCode.elementIsWriteOnly,
                                 `This is write only`));
    }

    if (!path.isEmpty) {
      return err(new SchemaError(
        ErrorCode.invalidArgumentError,
        `The path "${path.current}" is not empty.`));
    }

    return this.getter(data.toJS ? data.toJS() : data);
  }

  public set(path: Path, current: ComplexModel, value: string): Result<DataModel, SchemaError> {

    if (this.type === SimpleType.readOnly || !this.setter) {
      return err(new SchemaError(ErrorCode.elementIsReadOnly,
                                 `It is read only`));
    }

    if (!path.isEmpty) {
      return err(new SchemaError(
        ErrorCode.invalidArgumentError,
        `The path "${path.current}" is not empty.`));
    }

    return this.setter(current, value);
  }
}
